import type { FrontendModule } from '@/lib/types'
import { TasksPage } from './pages/TasksPage'

/**
 * Moduł `tasks` — „Zadania i zlecenia" (moduł OPCJONALNY, env `MODULES_ENABLED`).
 *
 * Trasa `/zadania` musi być identyczna z `NavItem.route` w manifeście backendu
 * (`app/modules/tasks/module.py`); nawigacja pochodzi wyłącznie z `/api/me/context`.
 */
export const tasksModule: FrontendModule = {
  key: 'tasks',
  routes: [{ path: 'zadania', element: <TasksPage /> }],
}

export default tasksModule
